module.exports = __webpack_public_path__ + "static/media/switch-to-light-theme-icon.cf71553d.svg";